import _extends from "@babel/runtime/helpers/esm/extends";
var _this = this;
import React, { useContext, useRef, useState } from 'react';
import Calendar from '../date-panel/Calendar';
import ClassNames from 'classnames';
import { getDateMatrix, moveToNextDate } from '../utils/dateUtilsOld';
import { getKeyTable, getFirstFocusDate } from '../utils/NavUtils';
import { CALENDAR_POSITION, CALENDAR_PANEL } from '../utils/constants';
import CalendarPickerContext from '../context/CalendarPickerContext';
export function sortTime(arr, returnCopy) {
  if (arr && arr.sort) {
    var result = returnCopy ? arr.slice() : arr;
    return result.sort(function (a, b) {
      return a.getTime() - b.getTime();
    });
  }
}
var DoubleCalendar = function DoubleCalendar(props) {
  var className = props.className,
    showOtherMonths = props.showOtherMonths,
    navigationLayoutMode = props.navigationLayoutMode,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    locale = props.locale,
    showInPicker = props.showInPicker,
    formatMonth = props.formatMonth,
    navigationLabel = props.navigationLabel,
    selectRange = props.selectRange,
    minDate = props.minDate,
    maxDate = props.maxDate,
    firstDayOfWeek = props.firstDayOfWeek,
    _props$autoClose = props.autoClose,
    autoClose = _props$autoClose === void 0 ? true : _props$autoClose;
  var _useContext = useContext(CalendarPickerContext),
    activeStartDateStore = _useContext.activeStartDateStore,
    viewStore = _useContext.viewStore,
    viewDispatch = _useContext.viewDispatch,
    activeStartDateDispatch = _useContext.activeStartDateDispatch,
    value = _useContext.value,
    valueDispatch = _useContext.valueDispatch,
    keyboardControlAreaDispatch = _useContext.keyboardControlAreaDispatch,
    keyboardControlStore = _useContext.keyboardControlStore,
    inputValueDispatch = _useContext.inputValueDispatch,
    openStatusDispatch = _useContext.openStatusDispatch,
    momentUtils = _useContext.momentUtils,
    maxDetail = _useContext.maxDetail,
    minDetail = _useContext.minDetail,
    disabledDates = _useContext.disabledDates,
    disabledRanges = _useContext.disabledRanges,
    disabledDays = _useContext.disabledDays,
    dateValidator = _useContext.dateValidator,
    setIsUsingKeyboard = _useContext.setIsUsingKeyboard;
  var isValidDateValueByRules = dateValidator.isValidDateValueByRules;
  var isBefore = momentUtils.isBefore,
    subtractDate = momentUtils.subtractDate,
    getStartDate = momentUtils.getStartDate,
    isAfter = momentUtils.isAfter,
    addDate = momentUtils.addDate;
  var view = viewStore.view;
  var leftCalendar = useRef(null);
  var rightCalendar = useRef(null);
  var _useState = useState(null),
    doubleHover = _useState[0],
    setDoubleHover = _useState[1];
  var onDoubleHover = function onDoubleHover(date) {
    setDoubleHover(date);
  };
  var onClickTile = function onClickTile(date, event, isKeyboard) {
    var currentValue = value;
    if (selectRange) {
      if (currentValue instanceof Date || !currentValue) {
        currentValue = [date];
      } else if (currentValue instanceof Array) {
        if (currentValue.length <= 1) {
          currentValue.push(date);
        } else {
          currentValue = [date];
        }
      }
      currentValue = sortTime(currentValue);
    } else {
      currentValue = date;
    }
    valueDispatch({
      type: 'setValue',
      payload: {
        value: currentValue
      }
    });
    inputValueDispatch({
      type: "setInputValueByDate",
      payload: {
        value: currentValue
      }
    });
    if (selectRange && currentValue.length === 2 && autoClose) {
      openStatusDispatch({
        type: "close",
        payload: {
          isKeyboard: isKeyboard
        }
      });
      keyboardControlAreaDispatch({
        type: "setInputFocus",
        payload: {
          isKeyboard: isKeyboard
        }
      });
    } else if (!selectRange && currentValue instanceof Date && autoClose) {
      openStatusDispatch({
        type: "close",
        payload: {
          isKeyboard: isKeyboard
        }
      });
      keyboardControlAreaDispatch({
        type: "setInputFocus",
        payload: {
          isKeyboard: isKeyboard
        }
      });
    }
  };
  var onClickYear = function onClickYear(date, event, isKeyboard) {
    if (maxDetail === 'decade') {
      onClickTile(date, event, isKeyboard);
    }
  };
  var onClickMonth = function onClickMonth(date, event, isKeyboard) {
    if (maxDetail === 'year') {
      onClickTile(date, event, isKeyboard);
    }
  };
  var onClickDay = function onClickDay(date, event, isKeyboard) {
    if (maxDetail === 'month') {
      onClickTile(date, event, isKeyboard);
    }
  };
  var onDirectionKeyDown = function onDirectionKeyDown(e, activeStartDateLeft, viewLeft, keyboardNavDateLeft, activeStartDateRight, viewRight, keyboardNavDateRight) {
    var firstDayOfWeek = props.firstDayOfWeek;
    var matrixLeft = getDateMatrix(activeStartDateLeft, viewLeft, firstDayOfWeek);
    var matrixRight = getDateMatrix(activeStartDateRight, viewRight, firstDayOfWeek);
    if (keyboardNavDateLeft) {
      var _moveToNextDate = moveToNextDate(e, viewLeft, null, keyboardNavDateLeft, activeStartDateLeft),
        _keyboardNavDate = _moveToNextDate.keyboardNavDate,
        activeStartDate = _moveToNextDate.activeStartDate;
      var _nextNavDate = _keyboardNavDate;
      var lastRow = matrixLeft[matrixLeft.length - 1];
      var endDateOfPanelLeft = lastRow[lastRow.length - 1];
      var startDateOfPanelLeft = matrixLeft[0][0];
      if (isBefore(_nextNavDate, startDateOfPanelLeft)) {
        var nextActiveStartDateLeft = activeStartDate;
        var nextActiveStartDateRight = activeStartDate;
        switch (viewLeft) {
          case "month":
            nextActiveStartDateLeft = getStartDate(subtractDate(_nextNavDate, 1, 'month'), 'month');
            nextActiveStartDateRight = getStartDate(_nextNavDate, 'month');
            break;
          case "year":
            nextActiveStartDateLeft = subtractDate(_nextNavDate, 23, 'month');
            nextActiveStartDateRight = subtractDate(_nextNavDate, 11, 'month');
            break;
          case "decade":
            nextActiveStartDateLeft = subtractDate(_nextNavDate, 23, 'year');
            nextActiveStartDateRight = subtractDate(_nextNavDate, 11, 'year');
            break;
          default:
            break;
        }
        keyboardControlAreaDispatch({
          type: "setNav",
          payload: {
            keyboardControlArea: "right_calendar_panel",
            keyboardNavDate: null,
            keyboardNavDateRight: _nextNavDate
          }
        });
        activeStartDateDispatch({
          type: "directSetActiveStartDate",
          payload: {
            activeStartDateLeft: nextActiveStartDateLeft,
            activeStartDateRight: nextActiveStartDateRight
          }
        });
      } else if (isAfter(_nextNavDate, endDateOfPanelLeft)) {
        keyboardControlAreaDispatch({
          type: "setNav",
          payload: {
            keyboardControlArea: "right_calendar_panel",
            keyboardNavDate: null,
            keyboardNavDateRight: matrixRight[0][0]
          }
        });
      } else {
        keyboardControlAreaDispatch({
          type: "setNav",
          payload: {
            keyboardNavDate: _keyboardNavDate
          }
        });
        activeStartDateDispatch({
          type: "directSetActiveStartDate",
          payload: {
            activeStartDateLeft: activeStartDate
          }
        });
      }
    } else if (keyboardNavDateRight) {
      var _moveToNextDate2 = moveToNextDate(e, viewRight, null, keyboardNavDateRight, activeStartDateRight),
        _keyboardNavDate2 = _moveToNextDate2.keyboardNavDate,
        _activeStartDate = _moveToNextDate2.activeStartDate;
      var _lastRow = matrixRight[matrixRight.length - 1];
      var endDateOfPanelRight = _lastRow[_lastRow.length - 1];
      var startDateOfPanelRight = matrixRight[0][0];
      var _nextNavDate2 = _keyboardNavDate2;
      if (isAfter(_nextNavDate2, endDateOfPanelRight)) {
        var _nextActiveStartDateRight = _activeStartDate;
        switch (viewLeft) {
          case "month":
            _nextActiveStartDateRight = addDate(_nextNavDate2, 1, 'month');
            break;
          case "year":
            _nextActiveStartDateRight = addDate(_nextNavDate2, 1, 'year');
            break;
          case "decade":
            _nextActiveStartDateRight = addDate(_nextNavDate2, 12, 'year');
            break;
          default:
            break;
        }
        keyboardControlAreaDispatch({
          type: "setNav",
          payload: {
            keyboardControlArea: "left_calendar_panel",
            keyboardNavDate: _nextNavDate2,
            keyboardNavDateRight: null
          }
        });
        activeStartDateDispatch({
          type: "directSetActiveStartDate",
          payload: {
            activeStartDateLeft: _nextNavDate2,
            activeStartDateRight: _nextActiveStartDateRight
          }
        });
      } else if (isBefore(_nextNavDate2, startDateOfPanelRight)) {
        var _lastRow2 = matrixLeft[matrixLeft.length - 1];
        keyboardControlAreaDispatch({
          type: "setNav",
          payload: {
            keyboardControlArea: "left_calendar_panel",
            keyboardNavDate: _lastRow2[_lastRow2.length - 1],
            keyboardNavDateRight: null
          }
        });
      } else {
        keyboardControlAreaDispatch({
          type: "setNav",
          payload: {
            keyboardNavDateRight: _nextNavDate2
          }
        });
        activeStartDateDispatch({
          type: "directSetActiveStartDate",
          payload: {
            activeStartDateRight: _activeStartDate
          }
        });
      }
    }
  };
  var onEnter = function onEnter(e, keyboardControlArea, viewLeft, viewRight, keyboardNavDateLeft, keyboardNavDateRight) {
    if (keyboardControlArea === "left_calendar_panel" && keyboardNavDateLeft && viewLeft === maxDetail) {
      if (isValidDateValueByRules({
        date: keyboardNavDateLeft,
        minDate: minDate,
        maxDate: maxDate,
        disabledDays: disabledDays,
        disabledDates: disabledDates,
        disabledRanges: disabledRanges,
        maxDetail: maxDetail
      })) {
        onClickTile(keyboardNavDateLeft, e, true);
      }
    } else if (keyboardControlArea === "right_calendar_panel" && keyboardNavDateRight && viewRight === maxDetail) {
      if (isValidDateValueByRules({
        date: keyboardNavDateRight,
        minDate: minDate,
        maxDate: maxDate,
        disabledDays: disabledDays,
        disabledDates: disabledDates,
        disabledRanges: disabledRanges,
        maxDetail: maxDetail
      })) {
        onClickTile(keyboardNavDateRight, e, true);
      }
    } /*  else if (keyboardControlArea && typeof keyboardControlArea === 'string' && keyboardControlArea.startsWith("right_")) {
        // rightCalendar.current.onKeyDown(e);
      }  */else if (!isNaN(Number(keyboardControlArea))) {
      props.onKeyDownForMenuMode(keyboardControlArea);
    } /* else {
      //leftCalendar.current.onKeyDown(e);
      } */
  };

  var onKeyDown = function onKeyDown(event) {
    if (!event.altKey && !event.ctrlKey) {
      setIsUsingKeyboard(true);
    }
    event.stopPropagation();
    if (props.disabled) {
      return;
    }
    var activeStartDateLeft = activeStartDateStore.activeStartDateLeft,
      activeStartDateRight = activeStartDateStore.activeStartDateRight;
    var _getKeyTable = getKeyTable(event),
      isTab = _getKeyTable.isTab,
      isEnter = _getKeyTable.isEnter,
      isDirection = _getKeyTable.isDirection,
      isChar = _getKeyTable.isChar,
      isBackspace = _getKeyTable.isBackspace,
      isSpace = _getKeyTable.isSpace;
    if (!isChar && !isBackspace && !isSpace) {
      event.preventDefault && event.preventDefault();
    }
    if (isTab) {
      keyboardControlAreaDispatch({
        type: "setNavWhenPressTab",
        payload: {
          event: event,
          value: value
        }
      });
    } else if (isDirection && keyboardControlArea && keyboardControlArea.includes && !keyboardControlArea.includes(CALENDAR_PANEL)) {
      var firstFocusDate = getFirstFocusDate(value || [], view, activeStartDateLeft);
      keyboardControlAreaDispatch({
        type: 'setNav',
        payload: {
          keyboardControlArea: "left_calendar_panel",
          keyboardNavDate: firstFocusDate,
          keyboardNavDateRight: null
        }
      });
    } else if (isEnter && keyboardControlArea) {
      onEnter(event, keyboardControlArea, view, view, keyboardNavDate, keyboardNavDateRight);
    } else if (keyboardControlArea && keyboardControlArea.includes && keyboardControlArea.includes(CALENDAR_PANEL) && isDirection) {
      onDirectionKeyDown(event, activeStartDateLeft, view, keyboardNavDate, activeStartDateRight, view, keyboardNavDateRight);
    }
  };
  var activeStartDateLeft = activeStartDateStore.activeStartDateLeft,
    activeStartDateRight = activeStartDateStore.activeStartDateRight;
  var keyboardControlArea = keyboardControlStore.keyboardControlArea,
    keyboardNavDate = keyboardControlStore.keyboardNavDate,
    keyboardNavDateRight = keyboardControlStore.keyboardNavDateRight;
  var keyboardControlAreaRight = keyboardControlArea;
  var keyboardControlAreaLeft = keyboardControlArea;
  if (keyboardControlArea && typeof keyboardControlArea === 'string' && keyboardControlArea.startsWith("right_")) {
    keyboardControlAreaRight = keyboardControlArea.replace("right_", "");
  } else if (keyboardControlArea && typeof keyboardControlArea === 'string' && keyboardControlArea.startsWith("left_")) {
    keyboardControlAreaLeft = keyboardControlArea.replace("left_", "");
  }
  var matrixLeft = [];
  var matrixRight = [];
  if (keyboardControlArea && keyboardControlArea.includes && keyboardControlArea.includes(CALENDAR_PANEL)) {
    matrixLeft = getDateMatrix(activeStartDateLeft, view);
    matrixRight = getDateMatrix(activeStartDateRight, view);
  }
  var totalCn = ClassNames("a-double-calendar-container", className, {
    "no-bottom-left-border-radius": keyboardControlArea === "left_calendar_panel" && matrixLeft.length >= matrixRight.length,
    "no-bottom-right-border-radius": keyboardControlArea === "right_calendar_panel" && matrixRight.length >= matrixLeft.length
  });
  var commonProps = {
    selectRange: selectRange,
    _isInDoubleCalendar: true,
    minDetail: minDetail,
    maxDetail: maxDetail,
    showOtherMonths: showOtherMonths,
    navigationLayoutMode: navigationLayoutMode,
    disabled: disabled,
    locale: locale,
    tabIndex: -1,
    showInPicker: showInPicker,
    hover: doubleHover,
    formatMonth: formatMonth,
    navigationLabel: navigationLabel,
    firstDayOfWeek: firstDayOfWeek,
    disabledDates: disabledDates,
    disabledRanges: disabledRanges,
    disabledDays: disabledDays,
    _onHover: onDoubleHover.bind(_this),
    onClickDay: onClickDay.bind(_this),
    onClickMonth: onClickMonth.bind(_this),
    onClickYear: onClickYear.bind(_this),
    momentUtils: momentUtils
  };
  return /*#__PURE__*/React.createElement("div", {
    className: totalCn,
    tabIndex: -1,
    onKeyDown: onKeyDown.bind(_this)
  }, /*#__PURE__*/React.createElement(Calendar, _extends({}, props, {
    openStatusDispatch: openStatusDispatch,
    ref: leftCalendar,
    value: value,
    maxDate: maxDate,
    activeStartDate: activeStartDateLeft,
    viewDispatch: viewDispatch,
    calendarPosition: CALENDAR_POSITION.LEFT,
    className: "ap-datepicker-left",
    minDate: minDate,
    activeStartDateDispatch: activeStartDateDispatch,
    view: view,
    inputValueDispatch: inputValueDispatch,
    keyboardNavDate: keyboardNavDate,
    keyboardControlArea: keyboardControlAreaLeft,
    keyboardControlAreaDispatch: keyboardControlAreaDispatch,
    dateValidator: dateValidator
  }, commonProps)), /*#__PURE__*/React.createElement("div", {
    className: "a-double-calendar-divider"
  }), /*#__PURE__*/React.createElement(Calendar, _extends({}, props, {
    dateValidator: dateValidator,
    openStatusDispatch: openStatusDispatch,
    ref: rightCalendar,
    activeStartDate: activeStartDateRight,
    value: value,
    showNavigationPrevNextBtn: true,
    calendarPosition: CALENDAR_POSITION.RIGHT,
    className: "ap-datepicker-right",
    maxDate: maxDate,
    minDate: minDate,
    activeStartDateDispatch: activeStartDateDispatch,
    view: view,
    viewDispatch: viewDispatch,
    inputValueDispatch: inputValueDispatch,
    keyboardNavDate: keyboardNavDateRight,
    keyboardControlArea: keyboardControlAreaRight,
    keyboardControlAreaDispatch: keyboardControlAreaDispatch
  }, commonProps)));
};
export default DoubleCalendar;